var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},_vm._l((_vm.numOfDot),function(n){return _c('div',{key:n,staticClass:"i",style:({
      'animation-duration': _vm.numOfDot * 0.4 + 's',
      'animation-delay': n * 0.4 + 's',
      width: _vm.dotRadius + 'px',
      height: _vm.dotRadius + 'px',
      'border-radius': _vm.dotRadius / 2 + 'px'
    })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }